// extracted by mini-css-extract-plugin
module.exports = {"lang":"kb","langWrap":"kc","item":"kd","itemCurrent":"ke"};